import WifiBox from "./WifiBox";

export default WifiBox;
